import styled from 'styled-components';
import { Header } from 'semantic-ui-react';

export const SectionHeader = styled(Header)`
  &&&& {
    margin-bottom: 0em;
  }
`;
